import type { ChangePasswordRequest } from '../../../domain/models/change-password'
import * as types from '../types/change-password-types'

export const changePasswordRequest = (payload: ChangePasswordRequest) => ({
  type: types.CHANGE_PASSWORD_REQUEST,
  payload,
})

export const changePasswordError = (payload: string) => ({
  type: types.CHANGE_PASSWORD_ERROR,
  payload,
})

export const changePasswordSuccess = (payload: boolean) => ({
  type: types.CHANGE_PASSWORD_SUCCESS,
  payload,
})

export const changePasswordReset = () => ({
  type: types.CHANGE_PASSWORD_RESET,
})
